 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-information</v-icon>
      <v-toolbar-title>Insured Details for {{ insuredRefNo }} - {{ insuredForm.fullName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-flex xs12 class="mt-2">
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.titleName }}</v-subheader>
              <div class="queryValue">{{ insuredForm.titleName }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.fullName }}</v-subheader>
              <div class="queryValue">{{ insuredForm.fullName }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.insdRefNoAe }}</v-subheader>
              <div class="queryValue">{{ formatBoolean(insuredForm.insdRefNoAe) }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.clientGrp }}</v-subheader>
              <div class="queryValue">{{ formatClientGrp(insuredForm.clientGrp) }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.clientType }}</v-subheader>
              <div class="queryValue">{{ insuredForm.clientType }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.postalCode }}</v-subheader>
              <div class="queryValue">{{ insuredForm.postalCode }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.address1 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.address1 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.address2 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.address2 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.address3 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.address3 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.address4 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.address4 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.abbrevName }}</v-subheader>
              <div class="queryValue">{{ insuredForm.abbrevName }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.contact }}</v-subheader>
              <div class="queryValue">{{ insuredForm.contact }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.telNo1 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.telNo1 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.telNo2 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.telNo2 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.telNo3 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.telNo3 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.telNo4 }}</v-subheader>
              <div class="queryValue">{{ insuredForm.telNo4 }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.email }}</v-subheader>
              <div class="queryValue">{{ insuredForm.email }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.web }}</v-subheader>
              <div class="queryValue">{{ insuredForm.web }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ insuredForm.strCreatedBy }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDate(insuredForm.createdDate) }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.createdProgId }}</v-subheader>
              <div class="queryValue">{{ insuredForm.createdProgId }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ insuredForm.strModifiedBy }}</div>
            </v-flex>
            <v-flex md4 lg4 xs12>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDate(insuredForm.modifiedDate) }}</div>
            </v-flex>
            <v-flex xs12>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Individual</span></div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.dob }}</v-subheader>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.icNo }}</v-subheader>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <div class="queryValue">{{ formatGender(insuredForm.gender) }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <div class="queryValue">{{ formatDate(insuredForm.dob) }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <div class="queryValue">{{ insuredForm.icNo }}</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="v-icon mdi mdi-plus theme--light d-flex">
                        <span class="headerTitle">Corporation</span>
                      </div>
                    </template>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.coRegNo }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.coRegNo }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.coRegDate }}</v-subheader>
                            <div class="queryValue">{{ formatDate(insuredForm.coRegDate) }}</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="v-icon mdi mdi-plus theme--light d-flex">
                        <span class="headerTitle">Other details and settings</span>
                      </div>
                    </template>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.gstRegNo }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.gstRegNo }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.gstRegDate }}</v-subheader>
                            <div class="queryValue">{{ formatDate(insuredForm.gstRegDate) }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.inactive }}</v-subheader>
                            <div class="queryValue">{{ formatBoolean(insuredForm.inactive) }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.blackList }}</v-subheader>
                            <div class="queryValue">{{ formatBoolean(insuredForm.blackList) }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.insdBillAcct }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.insdBillAcct }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.grpRefStmt }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.grpRefStmt }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.grpRefAge }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.grpRefAge }}</div>
                          </v-flex>
                          <v-flex md4 lg4 xs12>
                            <v-subheader class="queryLabel">{{ labels.grpRefStats }}</v-subheader>
                            <div class="queryValue">{{ insuredForm.grpRefStats }}</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      tabs: 0,
      toogleArray: [true, false, false, false],
      labels: {
        general: 'General',
        details: 'Details',
        insdRefNoAe: 'Insured Reference AE',
        insdRefNo: 'Insured Reference',
        clientGrp: 'Client Group',
        clientType: 'Client Type',
        titleName: 'Title',
        fullName: 'Full Name',
        postalCode: 'Postal Code',
        address1: 'Street Address/Block No.',
        address2: 'Unit No.',
        address3: 'Additional Address Line',
        address4: 'Building Name',
        address5: 'State',
        address6: 'Country',
        abbrevName: 'Abbreviated Name',
        contact: 'Contact Name',
        telNo1: 'Home Telephone',
        telNo2: 'Office Telephone',
        telNo3: 'Mobile',
        telNo4: 'Telephone',
        email: 'Email',
        web: 'Web page',
        gender: 'Gender',
        dob: 'Birthday',
        icNo: 'NRIC',
        coRegNo: 'Company Registration No.',
        coRegDate: 'Registration Date',
        gstRegNo: 'GST Registration No.',
        gstRegDate: 'GST Registration Date',
        inactive: 'Insured is Inactive',
        blackList: 'Insured is Blacklisted',
        insdBillAcct: 'Default Billing Account No.',
        grpRefStmt: 'Group Statement Insured Reference',
        grpRefAge: 'Group Ageing Insured No.',
        grpRefStats: 'Group Statistics Insured Reference',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        createdProgId: 'Created Program ID',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      insuredForm: {
        insdRefNoAe: false,
        insdRefNo: undefined,
        clientGrp: 'I',
        clientType: undefined,
        titleName: undefined,
        fullName: undefined,
        postalCode: undefined,
        address1: undefined,
        address2: undefined,
        address3: undefined,
        address4: undefined,
        abbrevName: undefined,
        contact: undefined,
        telNo1: undefined,
        telNo2: undefined,
        telNo3: undefined,
        telNo4: undefined,
        email: undefined,
        web: undefined,
        gender: 'N',
        dob: undefined,
        icNo: undefined,
        coRegNo: undefined,
        coRegDate: undefined,
        gstRegNo: undefined,
        gstRegDate: undefined,
        inactive: false,
        blackList: false,
        insdBillAcct: undefined,
        grpRefStmt: undefined,
        grpRefAge: undefined,
        grpRefStats: undefined,
        createdBy: undefined,
        createdDate: undefined,
        createdProgId: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      boolClientGrpI: false,
      boolClientGrpC: false
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.fetchInsured()
      }
    }
  },
  mounted() {
    this.fetchInsured()
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    async fetchInsured() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.getInsured
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            insdRefNo: this.insuredRefNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.insuredForm.insdRefNoAe = data.insured.insdRefNoAe
            this.insuredForm.clientGrp = data.insured.clientGrp
            this.insuredForm.clientType = data.insured.clientType
            this.insuredForm.titleName = data.insured.titleName
            this.insuredForm.fullName = data.insured.fullName
            this.insuredForm.postalCode = data.insured.postalCode
            this.insuredForm.address1 = data.insured.address1
            this.insuredForm.address2 = data.insured.address2
            this.insuredForm.address3 = data.insured.address3
            this.insuredForm.address4 = data.insured.address4
            this.insuredForm.abbrevName = data.insured.abbrevName
            this.insuredForm.contact = data.insured.contact
            this.insuredForm.telNo1 = data.insured.telNo1
            this.insuredForm.telNo2 = data.insured.telNo2
            this.insuredForm.telNo3 = data.insured.telNo3
            this.insuredForm.telNo4 = data.insured.telNo4
            this.insuredForm.email = data.insured.email
            this.insuredForm.web = data.insured.web
            this.insuredForm.gender = data.insured.gender
            this.insuredForm.dob = data.insured.dob
            this.insuredForm.icNo = data.insured.icNo
            this.insuredForm.coRegNo = data.insured.coRegNo
            this.insuredForm.coRegDate = data.insured.coRegDate
            this.insuredForm.gstRegNo = data.insured.gstRegNo
            this.insuredForm.gstRegDate = data.insured.gstRegDate
            this.insuredForm.inactive = data.insured.inactive
            this.insuredForm.blackList = data.insured.blackList
            this.insuredForm.insdBillAcct = data.insured.insdBillAcct
            this.insuredForm.grpRefStmt = data.insured.grpRefStmt
            this.insuredForm.grpRefAge = data.insured.grpRefAge
            this.insuredForm.grpRefStats = data.insured.grpRefStats
            this.insuredForm.strCreatedBy = data.strCreatedBy
            this.insuredForm.createdDate = data.insured.createdDate
            this.insuredForm.createdProgId = data.insured.createdProgId
            this.insuredForm.strModifiedBy = data.strModifiedBy
            this.insuredForm.modifiedDate = data.insured.modifiedDate
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    formatClientGrp(clientGrp) {
      if (clientGrp === 'I') {
        return 'Individual'
      } else if (clientGrp === 'C') {
        return 'Corporation'
      }
    },
    formatGender(gender) {
      if (gender === 'F') {
        return 'Female'
      } else if (gender === 'M') {
        return 'Male'
      } else {
        return 'Not Applicable'
      }
    }
  },
  computed: {},
  props: {
    insuredRefNo: {
      type: String,
      default: ''
    },
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: []
}
</script>
